import React, { useEffect, useState } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  TablePagination,
  Chip,
  Box,
  CircularProgress,
} from "@mui/material";
import { History as HistoryIcon } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { GetPlaceProductTriggerLogs } from "../../../../redux/actions/productSyncActions";
import SectionCard from "../SectionCard";

const TriggerLogTable = ({ triggerId }) => {
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!triggerId) return;
    const fetchLogs = async () => {
      try {
        setLoading(true);
        const result = await dispatch(GetPlaceProductTriggerLogs(triggerId, page + 1, pageSize));
        setRows(result?.data || []);
        setTotalCount(result?.recordsTotal || 0);
      } catch (error) {
        console.error("Log kayıtları alınamadı:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchLogs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerId, page, pageSize]);

  return (
    <SectionCard
      icon={HistoryIcon}
      title="İşlem Geçmişi"
      description="Arka plan işlemi tarafından oluşturulan senkronizasyon kayıtları"
    >
      <TableContainer sx={{ border: "1px solid #e5e5e5", borderRadius: 1.5 }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: "#fafafa" }}>
              <TableCell sx={{ fontWeight: 600 }}>Tarih</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Barkod</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Durum</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={3} align="center" sx={{ py: 3 }}>
                  <CircularProgress size={24} />
                </TableCell>
              </TableRow>
            ) : rows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={3} align="center" sx={{ py: 3, color: "text.secondary" }}>
                  Henüz bir kayıt yok
                </TableCell>
              </TableRow>
            ) : (
              rows.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>
                    {row.createDate ? new Date(row.createDate).toLocaleString("tr-TR") : ""}
                  </TableCell>
                  <TableCell>{row.barcode || "-"}</TableCell>
                  <TableCell>
                    {row.errorMessage ? (
                      <Chip label={row.errorMessage} color="error" size="small" variant="outlined" />
                    ) : (
                      <Chip label="Başarılı" color="success" size="small" variant="outlined" />
                    )}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <TablePagination
          component="div"
          count={totalCount}
          page={page}
          onPageChange={(e, newPage) => setPage(newPage)}
          rowsPerPage={pageSize}
          onRowsPerPageChange={(e) => {
            setPageSize(parseInt(e.target.value, 10));
            setPage(0);
          }}
          rowsPerPageOptions={[10, 25, 50]}
          labelRowsPerPage="Sayfa başına"
        />
      </Box>
    </SectionCard>
  );
};

export default TriggerLogTable;
